
!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{},n=(new e.Error).stack;n&&(e._sentryDebugIds=e._sentryDebugIds||{},e._sentryDebugIds[n]="b7edc606-a410-57e6-be70-2b7fed628449")}catch(e){}}();
(() => {
  'use strict';

  const ROOT_SELECTOR = '[data-hanezza-brand-reviews]';
  const CARD_SELECTOR = '.hanezza-air-review-card';
  const RESPONSE_SELECTOR = '.hanezza-air-merchant-response';

  function createChevronIcon() {
    const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute('viewBox', '0 0 20 20');
    svg.setAttribute('aria-hidden', 'true');
    svg.setAttribute('focusable', 'false');

    const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    path.setAttribute('d', 'M5 7.5 10 12.5 15 7.5');
    path.setAttribute('fill', 'none');
    path.setAttribute('stroke', 'currentColor');
    path.setAttribute('stroke-width', '1.8');
    path.setAttribute('stroke-linecap', 'round');
    path.setAttribute('stroke-linejoin', 'round');
    svg.appendChild(path);
    return svg;
  }

  function getCards(root) {
    const marked = Array.from(root.querySelectorAll(CARD_SELECTOR));
    if (marked.length) return marked;

    return Array.from(root.querySelectorAll(
      '[data-brand-review-widget] article, [data-brand-review-widget] [class*="review-card" i], [data-brand-review-widget] [class*="review-item" i]'
    )).filter((element) => String(element.textContent || '').trim().length > 35);
  }

  function findResponse(card) {
    const marked = Array.from(card.querySelectorAll(RESPONSE_SELECTOR));
    if (marked.length) {
      return marked.find((element) => !element.querySelector(RESPONSE_SELECTOR)) || marked[marked.length - 1];
    }

    const candidates = Array.from(card.querySelectorAll('div, section, aside')).filter((element) => {
      const value = String(element.textContent || '')
        .toLocaleLowerCase('tr-TR')
        .replace(/\s+/g, ' ')
        .trim();
      return value.includes('mağaza yanıtladı') || value.includes('satıcı yanıtladı') || value.includes('ردّ المتجر') || value.includes('پاسخ فروشگاه');
    });

    const response =
      candidates.find((element) => !candidates.some((candidate) => candidate !== element && element.contains(candidate))) ||
      candidates[0] ||
      null;

    if (response && !response.classList.contains('hanezza-air-merchant-response')) {
      response.classList.add('hanezza-air-merchant-response');
    }

    return response;
  }

  function ensureResponseToggle(root, card, index) {
    const response = findResponse(card);
    if (!response) return false;

    if (!response.classList.contains('is-mobile-collapsed')) {
      response.classList.add('is-mobile-collapsed');
    }

    if (!response.id) {
      const productId = String(root.dataset.productId || 'product').replace(/[^a-zA-Z0-9_-]/g, '');
      response.id = `HanezzaReviewResponse-${productId}-${index + 1}`;
    }

    let toggle = card.querySelector('.hanezza-merchant-response-toggle');
    if (!toggle) {
      toggle = document.createElement('button');
      toggle.type = 'button';
      toggle.className = 'hanezza-merchant-response-toggle';
      toggle.setAttribute('aria-expanded', 'false');

      const label = document.createElement('span');
      label.textContent = root.dataset.reviewResponseLabel || 'Hanezza yanıtı';
      toggle.append(label, createChevronIcon());

      toggle.addEventListener('click', () => {
        const nextExpanded = toggle.getAttribute('aria-expanded') !== 'true';
        toggle.setAttribute('aria-expanded', nextExpanded ? 'true' : 'false');
        response.classList.toggle('is-open', nextExpanded);
      });

      response.insertAdjacentElement('beforebegin', toggle);
    }

    if (toggle.getAttribute('aria-controls') !== response.id) {
      toggle.setAttribute('aria-controls', response.id);
    }

    const shouldOpen = toggle.getAttribute('aria-expanded') === 'true';
    if (response.classList.contains('is-open') !== shouldOpen) {
      response.classList.toggle('is-open', shouldOpen);
    }

    return true;
  }

  function updateListToggle(root, toggle, count) {
    const expanded = toggle.getAttribute('aria-expanded') === 'true';
    const showAllTemplate = root.dataset.reviewShowAll || 'Tüm __COUNT__ değerlendirmeyi gör';
    const nextText = expanded
      ? (root.dataset.reviewShowLess || 'Daha az göster')
      : showAllTemplate.replace('__COUNT__', String(count));
    if (toggle.textContent !== nextText) toggle.textContent = nextText;
  }

  function enhanceReviewList(root) {
    const cards = getCards(root);
    if (!cards.length) return;

    let toggle = root.querySelector('[data-hanezza-review-list-toggle]');
    const expanded = toggle?.getAttribute('aria-expanded') === 'true';

    cards.forEach((card, index) => {
      if (!card.classList.contains('hanezza-air-review-card')) {
        card.classList.add('hanezza-air-review-card');
      }

      const isExtra = index >= 3;
      if (card.classList.contains('hanezza-mobile-review-extra') !== isExtra) {
        card.classList.toggle('hanezza-mobile-review-extra', isExtra);
      }

      const shouldExpand = index < 3 || expanded;
      if (card.classList.contains('is-mobile-expanded') !== shouldExpand) {
        card.classList.toggle('is-mobile-expanded', shouldExpand);
      }

      ensureResponseToggle(root, card, index);
    });

    const list = root.querySelector('.hanezza-air-review-list') || cards[0].parentElement;
    if (!list || cards.length <= 3) {
      if (toggle && !toggle.hidden) toggle.hidden = true;
      return;
    }

    if (!list.id) {
      const productId = String(root.dataset.productId || 'product').replace(/[^a-zA-Z0-9_-]/g, '');
      list.id = `HanezzaReviewList-${productId}`;
    }

    if (!toggle) {
      toggle = document.createElement('button');
      toggle.type = 'button';
      toggle.className = 'hanezza-review-list-toggle';
      toggle.dataset.hanezzaReviewListToggle = 'true';
      toggle.setAttribute('aria-expanded', 'false');

      toggle.addEventListener('click', () => {
        const nextExpanded = toggle.getAttribute('aria-expanded') !== 'true';
        toggle.setAttribute('aria-expanded', nextExpanded ? 'true' : 'false');

        getCards(root).forEach((card, index) => {
          if (index < 3) return;
          if (card.classList.contains('is-mobile-expanded') !== nextExpanded) {
            card.classList.toggle('is-mobile-expanded', nextExpanded);
          }
        });

        updateListToggle(root, toggle, getCards(root).length);
      });
    }

    if (toggle.hidden) toggle.hidden = false;
    if (toggle.getAttribute('aria-controls') !== list.id) {
      toggle.setAttribute('aria-controls', list.id);
    }
    if (list.nextElementSibling !== toggle) {
      list.insertAdjacentElement('afterend', toggle);
    }

    updateListToggle(root, toggle, cards.length);
  }

  function mount(root) {
    if (!root || root.dataset.hanezzaMobileReviewUx === 'true') return;
    root.dataset.hanezzaMobileReviewUx = 'true';

    const host = root.querySelector('[data-brand-review-widget]');
    if (!host) return;

    let frame = 0;
    let applying = false;

    const apply = () => {
      if (applying) return;
      applying = true;
      try {
        enhanceReviewList(root);
      } finally {
        applying = false;
      }
    };

    const schedule = () => {
      window.cancelAnimationFrame(frame);
      frame = window.requestAnimationFrame(apply);
    };

    schedule();

    const observer = new MutationObserver((mutations) => {
      const hasExternalChildChange = mutations.some((mutation) => mutation.type === 'childList');
      if (hasExternalChildChange) schedule();
    });

    observer.observe(host, {
      childList: true,
      subtree: true
    });

    root.hanezzaMobileReviewObserver = observer;
  }

  function unmount(scope) {
    scope.querySelectorAll?.(ROOT_SELECTOR).forEach((root) => {
      root.hanezzaMobileReviewObserver?.disconnect();
      delete root.hanezzaMobileReviewObserver;
      delete root.dataset.hanezzaMobileReviewUx;
    });
  }

  function boot(scope = document) {
    scope.querySelectorAll?.(ROOT_SELECTOR).forEach(mount);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => boot(), { once: true });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', (event) => boot(event.target));
  document.addEventListener('shopify:section:unload', (event) => unmount(event.target));
})();
//# debugId=b7edc606-a410-57e6-be70-2b7fed628449
